import React from 'react';
import PropTypes from 'prop-types';

import './Card.css';

const Card = ({ children, title, className, style }) => (
  <div
    className={`tw-card ${className || ''}`}
    style={style}
  >
    {title && <h3 className="tw-card-title">{title}</h3>}
    {children}
  </div>
);

Card.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

Card.defaultProps = {
  children: null,
  title: null,
  className: '',
  style: {},
};

export default Card;
